module.exports = require.ensure([
  'swiper',
  'jquery',
  'vue',
  'object-assign',
  './swiper.amd.vue'
], function () {
  return require('./swiper.amd.vue');
})



// WEBPACK FOOTER //
// ./app/components/organisms/swiper/swiper.amd.js